import React from 'react';
import Grid from '@mui/material/Grid';
import ItemPointInfoUiSingleVoyage from './item/ItemPointInfoUiSingleVoyage'
import {useTranslation} from 'react-i18next';
import DateSvgIcon from "@resource/svg/DateSvgIcon";
import RadiusSvgIcon from "@resource/svg/RadiusSvgIcon";
import NumberSvgIcon from "@resource/svg/NumberSvgIcon";
import MarkerSvgIcon from "@resource/svg/MarkerSvgIcon";
import {SxType} from "@baseTypes/sx/sxTypes";
import {DATE_FORMAT_POINT_SINGLE_VOYAGE} from "@containers/singleVoyage/containers/points/constants/dateFormat";
import moment from 'moment'
import {TypeWayPointSingleVoyage} from "@containers/singleVoyage/types/point";
import SpeakerPhoneIcon from '@mui/icons-material/SpeakerPhone';
import GpsFixedIcon from '@mui/icons-material/GpsFixed';

interface IProps {
	address?: string,
	lat?: number,
	lng?: number,
	estimatedTimeArrival?: string,
	realTimeArrival?: string,
	plannedStayStop?: string,
	realStayStop?: string,
	plannedStayStart?: string,
	plannedStayEnd?: string,
	scheduledTime?: string,
	entryRadius?: number,
	name?: string,
	status?: string,
	numberStop?: number,
	countCompletedAssignments?: number
	type?: TypeWayPointSingleVoyage
	isTemplatePoint?: boolean
	sx?: SxType
}


const PointInfoViewSingleVoyage = ({
									   address,
									   name,
									   lng,
									   lat,
									   entryRadius,
									   estimatedTimeArrival,
									   realTimeArrival,
									   realStayStop,
									   plannedStayStart,
									   plannedStayEnd,
									   plannedStayStop,
									   countCompletedAssignments,
									   numberStop,
									   scheduledTime,
									   status,
									   type,
									   isTemplatePoint,
									   sx: sxProps = {}
								   }: IProps) => {
	const {t} = useTranslation()
	return (
		<Grid
			container
			columnSpacing={'5px'}
			rowSpacing={'5px'}
			sx={{
				minWidth: "250px",
				...sxProps,
			}}
		>
			{status && <ItemPointInfoUiSingleVoyage
                label={t('singleVoyage.status')}
                value={status}
                icon={<DateSvgIcon/>}
            />}
			{name && <ItemPointInfoUiSingleVoyage
                label={t('base.name')}
                value={name}
                icon={<DateSvgIcon/>}
            />}
			{address && <ItemPointInfoUiSingleVoyage
                label={t('base.address')}
                value={address}
                icon={<MarkerSvgIcon sx={{
					width: '10px',
					height: '10px',
					fill: '#B0AFB1'
				}}/>}
            />}
			{lat && <ItemPointInfoUiSingleVoyage
                label={t('base.lat')}
                value={lat}
                icon={<MarkerSvgIcon sx={{
					width: '10px',
					height: '10px',
					fill: '#B0AFB1'
				}}/>}
            />}
			{lng && <ItemPointInfoUiSingleVoyage
                label={t('base.lon')}
                value={lng}
                icon={<MarkerSvgIcon sx={{
					width: '10px',
					height: '10px',
					fill: '#B0AFB1'
				}}/>}
            />}
			{scheduledTime && <ItemPointInfoUiSingleVoyage
                label={t('singleVoyage.scheduledTime')}
                value={scheduledTime}
                icon={<DateSvgIcon/>}
            />}
			{plannedStayStart && <ItemPointInfoUiSingleVoyage
                label={t('singleVoyage.plannedStayStart')}
                value={moment(plannedStayStart).format(DATE_FORMAT_POINT_SINGLE_VOYAGE)}
                icon={<DateSvgIcon/>}
            />}
			{plannedStayEnd && <ItemPointInfoUiSingleVoyage
                label={t('singleVoyage.plannedStayEnd')}
                value={moment(plannedStayEnd).format(DATE_FORMAT_POINT_SINGLE_VOYAGE)}
                icon={<DateSvgIcon/>}
            />}
			{estimatedTimeArrival && <ItemPointInfoUiSingleVoyage
                label={t('singleVoyage.estimatedTimeArrival')}
                value={estimatedTimeArrival}
                icon={<DateSvgIcon/>}
            />}
			{realTimeArrival && <ItemPointInfoUiSingleVoyage
                label={t('singleVoyage.realTimeArrival')}
                value={realTimeArrival}
                icon={<DateSvgIcon/>}
            />}
			{plannedStayStop && <ItemPointInfoUiSingleVoyage
                label={t('singleVoyage.plannedStayStop')}
                value={plannedStayStop}
                icon={<DateSvgIcon/>}
            />}
			{realStayStop && <ItemPointInfoUiSingleVoyage
                label={t('singleVoyage.realStayStop')}
                value={realStayStop}
                icon={<DateSvgIcon/>}
            />}
			{entryRadius && <ItemPointInfoUiSingleVoyage
                label={t('singleVoyage.fixationRadiusGeozone')}
                value={entryRadius}
                icon={<RadiusSvgIcon/>}
            />}
			
			{numberStop >= 0 && <ItemPointInfoUiSingleVoyage
                label={t('singleVoyage.numberStop')}
                value={numberStop}
                icon={<NumberSvgIcon/>}
            />}
			
			{countCompletedAssignments > 0 && <ItemPointInfoUiSingleVoyage
                label={t('singleVoyage.countCompletedAssignments')}
                value={countCompletedAssignments}
                icon={<DateSvgIcon/>}
            />}
			
			{isTemplatePoint && <ItemPointInfoUiSingleVoyage
                label={t('base.pointTemplate')}
                value={t('base.yes')}
                icon={<GpsFixedIcon sx={{
					width: '13px',
					height: '13px',
					fill: '#B0AFB1'
				}}/>}
            />}
			
			{type && type === 'RFID_POINT' && <ItemPointInfoUiSingleVoyage
                label={t('base.rfid')}
                value={t('base.yes')}
                icon={<SpeakerPhoneIcon sx={{
					width: '13px',
					height: '13px',
					fill: '#B0AFB1'
				}}/>}
            />}
		</Grid>
	);
};

export default PointInfoViewSingleVoyage;
